const A = "extra-spacing";
export {
  A as PARAGRAPH_EXTRA_SPACING_ATTRIBUTE
};
